import { ConsumptionPlaceModel } from './consumptionPlace.model';
import { MeterModel } from './meter.model';
import { PhotoModel } from './photo.model';
import { ReportModel } from './report.model';

export enum PublicUtilityType {
  ELECTRICITY = '1',
  GAS = '2',
}

export interface DeviceModel {
  id: number;
  serialNumber: string;
  type: string;
  publicUtilityType: string;
  consumptionPlaceId: number;
  consumptionPlace?: ConsumptionPlaceModel;
  materialNumber: string;
  certificationYear: number;
  manufacturedYear: number;
  functionClass: string;
  controlSerialNumber: string;
  placement: string;
  hasSitePhoto: boolean;
  bindingId: string;
  isMeterDevice: boolean;
  proprietary: string;
  magneticSwitchType: string;
  tariffKind: string;
  meters: MeterModel[];
  reports: ReportModel[];
  photos: PhotoModel[];
}
